export default "__VITE_ASSET__CuAG2xaz__"